

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./CategoryManager.css";


// const API_BASE = "https://grocerrybackend.vercel.app/api/categories";

// const emptyCategoryForm = { name: "", image: null };
// const emptySubForm = { name: "", image: null };

// const CategoryManager = () => {
//   const [categories, setCategories] = useState([]);
//   const [catForm, setCatForm] = useState(emptyCategoryForm);
//   const [editCatId, setEditCatId] = useState(null);
// const [openMenuId, setOpenMenuId] = useState(null);
//   const [expandedCat, setExpandedCat] = useState(null);
//   const [subForm, setSubForm] = useState(emptySubForm);
//   const [showCatForm, setShowCatForm] = useState(false);

//   const [editSubInfo, setEditSubInfo] = useState({ catId: null, subId: null });

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;

//   const [searchText, setSearchText] = useState("");

//   // Modal state
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMode, setModalMode] = useState("category"); // "category" | "subcategory"
//   const [modalTarget, setModalTarget] = useState({ catId: null, subId: null });

//   // local preview for modal image
//   const [modalPreview, setModalPreview] = useState(null);

//   const fileInputRef = useRef(null);

//   /* ------------------- Fetch Categories -------------------- */
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(API_BASE);
//       const cats = res.data.categories || res.data.data || [];
//       setCategories(
//         cats.map((c) => ({
//           ...c,
//           subcategories: Array.isArray(c.subcategories) ? c.subcategories : [],
//         }))
//       );
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load categories");
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   /* ------------------- Category Input -------------------- */
//   const onCatInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setCatForm((p) => ({ ...p, image: files[0] }));
//     } else {
//       setCatForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   /* ------------------- Save Category (Add / Update) -------------------- */
//   const submitCategory = async (e) => {
//     e.preventDefault();

//     if (!catForm.name.trim()) return toast.warn("Enter category name");

//     const fd = new FormData();
//     fd.append("name", catForm.name);
//     if (catForm.image) fd.append("image", catForm.image);

//     try {
//       if (editCatId) {
//         await axios.put(`${API_BASE}/${editCatId}`, fd);
//         toast.success("Category updated");
//       } else {
//         await axios.post(API_BASE, fd);
//         toast.success("Category added");
//       }
//       setCatForm(emptyCategoryForm);
//       setEditCatId(null);
//       fetchCategories();
//     } catch (err) {
//       console.error(err);
//       toast.error("Save failed");
//     }
//   };

//   /* ------------------- Delete Category -------------------- */
//   const deleteCategory = async (id) => {
//     if (!window.confirm("Delete this category?")) return;
//     try {
//       await axios.delete(`${API_BASE}/${id}`);
//       toast.success("Category deleted");
//       fetchCategories();
//     } catch (err) {
//       console.error(err);
//       toast.error("Delete failed");
//     }
//   };

//   /* ------------------- Sub Input -------------------- */
//   const onSubInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setSubForm((p) => ({ ...p, image: files[0] }));
//     } else {
//       setSubForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   /* ------------------- Save Subcategory -------------------- */
//   const submitSub = async (e, catId) => {
//     e.preventDefault();

//     if (!subForm.name.trim()) return toast.warn("Enter subcategory name");

//     const fd = new FormData();
//     fd.append("name", subForm.name);
//     if (subForm.image) fd.append("image", subForm.image);

//     try {
//       if (editSubInfo.subId) {
//         await axios.put(
//           `${API_BASE}/${editSubInfo.catId}/sub/${editSubInfo.subId}`,
//           fd
//         );
//         toast.success("Subcategory updated");
//       } else {
//         await axios.post(`${API_BASE}/${catId}/sub`, fd);
//         toast.success("Subcategory added");
//       }

//       setSubForm(emptySubForm);
//       setEditSubInfo({ catId: null, subId: null });
//       fetchCategories();
//     } catch (err) {
//       console.error(err);
//       toast.error("Save failed");
//     }
//   };

//   /* ------------------- Delete Subcategory -------------------- */
//   const deleteSub = async (catId, subId) => {
//     if (!window.confirm("Delete this subcategory?")) return;

//     try {
//       await axios.delete(`${API_BASE}/${catId}/sub/${subId}`);
//       toast.success("Subcategory deleted");
//       fetchCategories();
//     } catch (err) {
//       console.error(err);
//       toast.error("Delete failed");
//     }
//   };

//   /* ------------------- Modal handlers -------------------- */
//   const openCategoryModal = (cat) => {
//     setModalMode("category");
//     setModalTarget({ catId: cat._id, subId: null });
//     setModalPreview(cat.image || null);
//     setCatForm({ name: cat.name || "", image: null });
//     setIsModalOpen(true);
//   };

//   const openSubModal = (cat, sub) => {
//     setModalMode("subcategory");
//     setModalTarget({ catId: cat._id, subId: sub._id });
//     setModalPreview(sub.image || null);
//     setSubForm({ name: sub.name || "", image: null });
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setModalPreview(null);
//     setModalTarget({ catId: null, subId: null });
//     setCatForm(emptyCategoryForm);
//     setSubForm(emptySubForm);
//     setEditCatId(null);
//     setEditSubInfo({ catId: null, subId: null });
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const handleModalImageChange = (e) => {
//     const file = e.target.files && e.target.files[0];
//     if (file) {
//       setModalPreview(URL.createObjectURL(file));
//       if (modalMode === "category") {
//         setCatForm((p) => ({ ...p, image: file }));
//       } else {
//         setSubForm((p) => ({ ...p, image: file }));
//       }
//     }
//   };

//   const saveModal = async (e) => {
//     e.preventDefault();
//     try {
//       if (modalMode === "category") {
//         if (!catForm.name.trim()) return toast.warn("Enter category name");
//         const fd = new FormData();
//         fd.append("name", catForm.name);
//         if (catForm.image) fd.append("image", catForm.image);
//         await axios.put(`${API_BASE}/${modalTarget.catId}`, fd);
//         toast.success("Category updated");
//       } else {
//         if (!subForm.name.trim()) return toast.warn("Enter subcategory name");
//         const fd = new FormData();
//         fd.append("name", subForm.name);
//         if (subForm.image) fd.append("image", subForm.image);
//         await axios.put(
//           `${API_BASE}/${modalTarget.catId}/sub/${modalTarget.subId}`,
//           fd
//         );
//         toast.success("Subcategory updated");
//       }
//       closeModal();
//       fetchCategories();
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//     }
//   };

//   /* ------------------- Search filter -------------------- */
//   const filterCategories = (cats, q) => {
//     if (!q || !q.trim()) return cats;
//     const t = q.trim().toLowerCase();

//     // show categories where category name matches OR any subcategory matches
//     return cats
//       .map((c) => {
//         const matchedSubs = c.subcategories.filter((s) =>
//           (s.name || "").toLowerCase().includes(t)
//         );
//         const categoryMatches = (c.name || "").toLowerCase().includes(t);
//         if (categoryMatches) return { ...c }; // show full category
//         if (matchedSubs.length) {
//           // if only sub matches, include category but only matched subs (for clarity)
//           return { ...c, subcategories: matchedSubs };
//         }
//         return null;
//       })
//       .filter(Boolean);
//   };

//   /* ------------------- Pagination -------------------- */
//   const filtered = filterCategories(categories, searchText);
//   const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
//   useEffect(() => {
//     if (currentPage > totalPages) setCurrentPage(1);
    
//   }, [filtered.length, totalPages]);

//   const lastIndex = currentPage * itemsPerPage;
//   const firstIndex = lastIndex - itemsPerPage;
//   const currentCats = filtered.slice(firstIndex, lastIndex);
// <button
//   className="add-cat-btn"
//   onClick={() => setShowCatForm(!showCatForm)}
// >
//   {showCatForm ? "Close" : "Add Category"}
// </button>

//   /* ------------------- UI -------------------- */
//   return (
//     <div className="category-container">
//       <ToastContainer />
 
//       <div className="header">
//         <h2>📂 Category Manager</h2>
//         <p>Add categories & subcategories (mobile-friendly)</p>

// <input
//           className="search-input"
//           placeholder="Search categories or subcategories..."
//           value={searchText}
//           onChange={(e) => {
//             setSearchText(e.target.value);
//             setCurrentPage(1);
//           }}
//         /> 
        
//       </div>

     

//       {/* Search + Category Form */}
//       <div className="top-row">
        
        

//         <form className="category-form" onSubmit={submitCategory}>
//           <div className="form-row">
//             <input
//               name="name"
//               type="text"
//               placeholder="Enter category name"
//               value={catForm.name}
//               onChange={onCatInputChange}
//             />

//             <input
//               name="image"
//               type="file"
//               accept="image/*"
//               onChange={onCatInputChange}
//             />

//             <button type="submit">
//               {editCatId ? "Update Category" : "Add Category"}
//             </button>

//             {editCatId && (
//               <button
//                 className="cancel-btn"
//                 type="button"
//                 onClick={() => setEditCatId(null)}
//               >
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>

//       {/* ------------------ Desktop Table ------------------ */}
//       <div className="category-list">
//         <table>
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Image</th>
//               <th>Name</th>
//               <th>Subcategories</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentCats.map((cat, i) => (
//               <React.Fragment key={cat._id}>
//                 <tr>
//                   <td>{firstIndex + i + 1}</td>
//                   <td>
//                     {cat.image ? (
//                       <img src={cat.image} className="table-img" alt="" />
//                     ) : (
//                       "No Image"
//                     )}
//                   </td>
//                   <td>{cat.name}</td>

//                   <td>
//                     {cat.subcategories.length}{" "}
//                     <button
//                       className="small-btn"
//                       onClick={() =>
//                         setExpandedCat(expandedCat === cat._id ? null : cat._id)
//                       }
//                     >
//                       {expandedCat === cat._id ? "Hide" : "Manage"}
//                     </button>
//                   </td>

//                   {/* <td>
//                     <button
//                       onClick={() => openCategoryModal(cat)}
//                       className="edit-btn"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => deleteCategory(cat._id)}
//                       className="delete-btn"
//                     >
//                       Delete
//                     </button>
//                   </td> */}

//                       <td>
//   <div className="dots-wrap">
//     <button
//       className="dots-btn"
//       onClick={(e) => {
//         e.stopPropagation();
//         setExpandedCat(null); // menu click se sub collapse na ho
//         setOpenMenuId(openMenuId === cat._id ? null : cat._id);
//       }}
//     >
//       ⋯
//     </button>

//     {openMenuId === cat._id && (
//       <div className="dots-menu">
//         <button
//           className="menu-item"
//           onClick={() => {
//             openCategoryModal(cat);
//             setOpenMenuId(null);
//           }}
//         >
//           Edit
//         </button>

//         <button
//           className="menu-item"
//           onClick={() => {
//             deleteCategory(cat._id);
//             setOpenMenuId(null);
//           }}
//         >
//           Delete
//         </button>
//       </div>
//     )}
//   </div>
// </td>





//                 </tr>

//                 {/* Sub category section */}
//                 {expandedCat === cat._id && (
//                   <tr>
//                     <td colSpan="5">
//                       <div className="sub-section">
//                         <h4>{cat.name} - Subcategories</h4>

//                         <div className="sub-list">
//                           {cat.subcategories.map((sub) => (
//                             <div className="sub-item" key={sub._id}>
//                               <div className="sub-left">
//                                 {sub.image ? (
//                                   <img
//                                     src={sub.image}
//                                     className="sub-thumb"
//                                     alt=""
//                                   />
//                                 ) : (
//                                   <div className="sub-thumb no-img">No</div>
//                                 )}
//                                 <div className="sub-name">{sub.name}</div>
//                               </div>
// {/* 
//                               <div className="sub-actions">
//                                 <button
//                                   className="edit-btn small"
//                                   onClick={() => openSubModal(cat, sub)}
//                                 >
//                                   Edit
//                                 </button>

//                                 <button
//                                   className="delete-btn small"
//                                   onClick={() => deleteSub(cat._id, sub._id)}
//                                 >
//                                   Delete
//                                 </button>
//                               </div> */}
// <div className="dots-wrap">
//   <button
//     className="dots-btn small-dots"
//     onClick={(e) => {
//       e.stopPropagation();
//       setOpenMenuId(openMenuId === sub._id ? null : sub._id);
//     }}
//   >
//     ⋯
//   </button>

//   {openMenuId === sub._id && (
//     <div className="dots-menu">
//       <button
//         className="menu-item"
//         onClick={() => {
//           openSubModal(cat, sub);
//           setOpenMenuId(null);
//         }}
//       >
//         Edit
//       </button>

//       <button
//         className="menu-item"
//         onClick={() => {
//           deleteSub(cat._id, sub._id);
//           setOpenMenuId(null);
//         }}
//       >
//         Delete
//       </button>
//     </div>
//   )}
// </div>




//                             </div>
//                           ))}
//                         </div>

//                         {/* Sub Form */}
//                         <form
//                           className="sub-form"
//                           onSubmit={(e) => submitSub(e, cat._id)}
//                         >
//                           <input
//                             name="name"
//                             type="text"
//                             placeholder="Subcategory name"
//                             value={subForm.name}
//                             onChange={onSubInputChange}
//                           />

//                           <input
//                             name="image"
//                             type="file"
//                             accept="image/*"
//                             onChange={onSubInputChange}
//                           />

//                           <button type="submit">
//                             {editSubInfo.subId ? "Update Sub" : "Add Sub"}
//                           </button>
//                         </form>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* ------------------ Mobile Cards ------------------ */}
     

//       {/* Pagination */}
//       <div className="pagination">
//         <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
//           Prev
//         </button>

//         {Array.from({ length: totalPages }).map((_, i) => (
//           <button
//             key={i}
//             className={currentPage === i + 1 ? "active-page" : ""}
//             onClick={() => setCurrentPage(i + 1)}
//           >
//             {i + 1}
//           </button>
//         ))}

//         <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
//           Next
//         </button>
//       </div>

//       {/* ------------------- Modal (simple centered) ------------------- */}
//       {isModalOpen && (
//         <div className="cm-modal-overlay" onMouseDown={closeModal}>
//           <div className="cm-modal" onMouseDown={(e) => e.stopPropagation()}>
//             <h3>{modalMode === "category" ? "Edit Category" : "Edit Subcategory"}</h3>

//             <form onSubmit={saveModal} className="cm-modal-form">
//               {modalMode === "category" ? (
//                 <>
//                   <label className="modal-label">Name</label>
//                   <input
//                     name="name"
//                     value={catForm.name}
//                     onChange={(e) => setCatForm((p) => ({ ...p, name: e.target.value }))}
//                   />

//                   <label className="modal-label">Image</label>
//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/*"
//                     onChange={handleModalImageChange}
//                   />

//                   {modalPreview && (
//                     <div className="modal-preview">
//                       <img src={modalPreview} alt="preview" />
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <>
//                   <label className="modal-label">Subcategory Name</label>
//                   <input
//                     name="name"
//                     value={subForm.name}
//                     onChange={(e) => setSubForm((p) => ({ ...p, name: e.target.value }))}
//                   />

//                   <label className="modal-label">Image</label>
//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/*"
//                     onChange={handleModalImageChange}
//                   />

//                   {modalPreview && (
//                     <div className="modal-preview">
//                       <img src={modalPreview} alt="preview" />
//                     </div>
//                   )}
//                 </>
//               )}

//               <div className="modal-actions">
//                 <button type="submit" className="btn-primary">
//                   Update
//                 </button>
//                 <button type="button" className="btn-cancel" onClick={closeModal}>
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CategoryManager;

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./CategoryManager.css";

// const API_BASE = "https://grocerrybackend.vercel.app/api/categories";

// const emptyCategoryForm = { name: "", image: null };
// const emptySubForm = { name: "", image: null };

// const CategoryManager = () => {
//   const [categories, setCategories] = useState([]);
//   const [catForm, setCatForm] = useState(emptyCategoryForm);
//   const [editCatId, setEditCatId] = useState(null);
//   const [showCatForm, setShowCatForm] = useState(false);

//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [expandedCat, setExpandedCat] = useState(null);

//   const [subForm, setSubForm] = useState(emptySubForm);
//   const [editSubInfo, setEditSubInfo] = useState({ catId: null, subId: null });

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;

//   const [searchText, setSearchText] = useState("");

//   // Modal Edit Popup
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMode, setModalMode] = useState("category");
//   const [modalTarget, setModalTarget] = useState({ catId: null, subId: null });
//   const [modalPreview, setModalPreview] = useState(null);
//   const fileInputRef = useRef(null);

//   /* ------------------- Fetch Categories -------------------- */
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(API_BASE);
//       const cats = res.data.categories || res.data.data || [];

//       setCategories(
//         cats.map((c) => ({
//           ...c,
//           subcategories: Array.isArray(c.subcategories)
//             ? c.subcategories
//             : [],
//         }))
//       );
//     } catch (err) {
//       toast.error("Failed to load categories");
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   /* ------------------- SEARCH FILTER FIX -------------------- */
//   const filterCategories = (cats, q) => {
//     if (!q || !q.trim()) return cats;

//     const t = q.toLowerCase();

//     return cats
//       .map((c) => {
//         const matchedSubs = c.subcategories.filter((s) =>
//           s.name.toLowerCase().includes(t)
//         );

//         const categoryMatches = c.name.toLowerCase().includes(t);

//         if (categoryMatches) return c;

//         if (matchedSubs.length) {
//           return { ...c, subcategories: matchedSubs };
//         }

//         return null;
//       })
//       .filter(Boolean);
//   };

//   /* ------------------- CATEGORY INPUT -------------------- */
//   const onCatInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) setCatForm((p) => ({ ...p, image: files[0] }));
//     else setCatForm((p) => ({ ...p, [name]: value }));
//   };

//   /* ------------------- SUB INPUT -------------------- */
//   const onSubInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) setSubForm((p) => ({ ...p, image: files[0] }));
//     else setSubForm((p) => ({ ...p, [name]: value }));
//   };

//   /* ------------------- SAVE CATEGORY -------------------- */
//   const submitCategory = async (e) => {
//     e.preventDefault();

//     if (!catForm.name.trim()) return toast.warn("Enter category name");

//     const fd = new FormData();
//     fd.append("name", catForm.name);
//     if (catForm.image) fd.append("image", catForm.image);

//     try {
//       if (editCatId) {
//         await axios.put(`${API_BASE}/${editCatId}`, fd);
//         toast.success("Category updated");
//       } else {
//         await axios.post(API_BASE, fd);
//         toast.success("Category added");
//       }

//       setCatForm(emptyCategoryForm);
//       setEditCatId(null);
//       fetchCategories();
//     } catch (err) {
//       toast.error("Failed to save category");
//     }
//   };

//   /* ------------------- DELETE CATEGORY -------------------- */
//   const deleteCategory = async (id) => {
//     if (!window.confirm("Delete this category?")) return;

//     try {
//       await axios.delete(`${API_BASE}/${id}`);
//       toast.success("Category deleted");
//       fetchCategories();
//     } catch {
//       toast.error("Failed to delete category");
//     }
//   };

//   /* ------------------- SAVE SUBCATEGORY -------------------- */
//   const submitSub = async (e, catId) => {
//     e.preventDefault();
//     if (!subForm.name.trim()) return toast.warn("Enter subcategory name");

//     const fd = new FormData();
//     fd.append("name", subForm.name);
//     if (subForm.image) fd.append("image", subForm.image);

//     try {
//       if (editSubInfo.subId) {
//         await axios.put(
//           `${API_BASE}/${editSubInfo.catId}/sub/${editSubInfo.subId}`,
//           fd
//         );
//         toast.success("Subcategory updated");
//       } else {
//         await axios.post(`${API_BASE}/${catId}/sub`, fd);
//         toast.success("Subcategory added");
//       }

//       setSubForm(emptySubForm);
//       setEditSubInfo({ catId: null, subId: null });
//       fetchCategories();
//     } catch {
//       toast.error("Failed to save subcategory");
//     }
//   };

//   /* ------------------- DELETE SUBCATEGORY -------------------- */
//   const deleteSub = async (catId, subId) => {
//     if (!window.confirm("Delete this subcategory?")) return;

//     try {
//       await axios.delete(`${API_BASE}/${catId}/sub/${subId}`);
//       toast.success("Subcategory deleted");
//       fetchCategories();
//     } catch {
//       toast.error("Failed to delete subcategory");
//     }
//   };

//   /* ------------------- MODAL HANDLERS -------------------- */
//   const openCategoryModal = (cat) => {
//     setModalMode("category");
//     setModalTarget({ catId: cat._id, subId: null });
//     setModalPreview(cat.image);
//     setCatForm({ name: cat.name, image: null });
//     setIsModalOpen(true);
//   };

//   const openSubModal = (cat, sub) => {
//     setModalMode("subcategory");
//     setModalTarget({ catId: cat._id, subId: sub._id });
//     setModalPreview(sub.image);
//     setSubForm({ name: sub.name, image: null });
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setModalPreview(null);
//     setModalTarget({ catId: null, subId: null });
//     setCatForm(emptyCategoryForm);
//     setSubForm(emptySubForm);
//   };

//   const handleModalImageChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setModalPreview(URL.createObjectURL(file));
//       if (modalMode === "category")
//         setCatForm((p) => ({ ...p, image: file }));
//       else setSubForm((p) => ({ ...p, image: file }));
//     }
//   };

//   const saveModal = async (e) => {
//     e.preventDefault();

//     try {
//       const fd = new FormData();

//       if (modalMode === "category") {
//         fd.append("name", catForm.name);
//         if (catForm.image) fd.append("image", catForm.image);

//         await axios.put(`${API_BASE}/${modalTarget.catId}`, fd);
//         toast.success("Category updated");
//       } else {
//         fd.append("name", subForm.name);
//         if (subForm.image) fd.append("image", subForm.image);

//         await axios.put(
//           `${API_BASE}/${modalTarget.catId}/sub/${modalTarget.subId}`,
//           fd
//         );
//         toast.success("Subcategory updated");
//       }

//       closeModal();
//       fetchCategories();
//     } catch {
//       toast.error("Update failed");
//     }
//   };

//   /* ------------------- PAGINATION -------------------- */
//   const filtered = filterCategories(categories, searchText);
//   const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));

//   useEffect(() => {
//     if (currentPage > totalPages) setCurrentPage(1);
//   }, [filtered.length, totalPages]);

//   const lastIndex = currentPage * itemsPerPage;
//   const firstIndex = lastIndex - itemsPerPage;
//   const currentCats = filtered.slice(firstIndex, lastIndex);

//   /* ------------------- UI -------------------- */
//   return (
//     <div className="category-container">
//       <ToastContainer />

//       <div className="header">
//         <h2> Category Manager</h2>
//         {/* <p>Add categories & subcategories (mobile-friendly)</p> */}

//         {/* <input
//           className="search-input"
//           placeholder="Search..."
//           value={searchText}
//           onChange={(e) => {
//             setSearchText(e.target.value);
//             setCurrentPage(1);
//           }}
//         />

//         <button
//           className="add-cat-btn"
//           onClick={() => setShowCatForm(!showCatForm)}
//         >
//           {showCatForm ? "Close" : "Add Category"}
//         </button> */}
// {/* 
//         <div className="header-row">
//   <input
//     className="search-input"
//     placeholder="Search..."
//     value={searchText}
//     onChange={(e) => {
//       setSearchText(e.target.value);
//       setCurrentPage(1);
//     }}
//   />

//   <button
//     className="add-cat-btn"
//     onClick={() => setShowCatForm(!showCatForm)}
//   >
//     {showCatForm ? "Close" : "Add Category"}
//   </button>
// </div> */}
// <div className="header-row-fixed">
//   <input
//     className="search-input-fixed"
//     placeholder="Search..."
//     value={searchText}
//     onChange={(e) => {
//       setSearchText(e.target.value);
//       setCurrentPage(1);
//     }}
//   />

//   <button
//     className="add-cat-btn-fixed"
//     onClick={() => setShowCatForm(!showCatForm)}
//   >
//     {showCatForm ? "Close" : "Add Category"}
//   </button>
// </div>

//       </div>

//       {/* CATEGORY FORM TOGGLE */}
//       {showCatForm && (
//         <div className="top-row slide-down">
//           <form className="category-form" onSubmit={submitCategory}>
//             <div className="form-row">
//               <input
//                 name="name"
//                 type="text"
//                 placeholder="Enter category name"
//                 value={catForm.name}
//                 onChange={onCatInputChange}
//               />

//               <input
//                 name="image"
//                 type="file"
//                 accept="image/*"
//                 onChange={onCatInputChange}
//               />

//               <button type="submit">
//                 {editCatId ? "Update Category" : "Add Category"}
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* CATEGORY TABLE */}
//       <div className="category-list">
//         <table>
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Image</th>
//               <th>Name</th>
//               <th>Subcategories</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentCats.map((cat, i) => (
//               <React.Fragment key={cat._id}>
//                 <tr>
//                   <td>{firstIndex + i + 1}</td>
//                   <td>
//                     {cat.image ? (
//                       <img src={cat.image} className="table-img" alt="" />
//                     ) : (
//                       "No Image"
//                     )}
//                   </td>

//                   <td>{cat.name}</td>

//                   <td>
//                     {cat.subcategories.length}{" "}
//                     <button
//                       className="small-btn"
//                       onClick={() =>
//                         setExpandedCat(
//                           expandedCat === cat._id ? null : cat._id
//                         )
//                       }
//                     >
//                       {expandedCat === cat._id ? "Hide" : "Manage"}
//                     </button>
//                   </td>

//                   <td>
//                     <div className="dots-wrap">
//                       <button
//                         className="dots-btn"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setOpenMenuId(
//                             openMenuId === cat._id ? null : cat._id
//                           );
//                         }}
//                       >
//                         ⋯
//                       </button>

//                       {openMenuId === cat._id && (
//                         <div className="dots-menu">
//                           <button
//                             className="menu-item"
//                             onClick={() => {
//                               openCategoryModal(cat);
//                               setOpenMenuId(null);
//                             }}
//                           >
//                             Edit
//                           </button>

//                           <button
//                             className="menu-item"
//                             onClick={() => {
//                               deleteCategory(cat._id);
//                               setOpenMenuId(null);
//                             }}
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                 </tr>

//                 {/* SUBCATEGORY SECTION */}
//                 {expandedCat === cat._id && (
//                   <tr>
//                     <td colSpan="5">
//                       <div className="sub-section">
//                         <h4>{cat.name} - Subcategories</h4>

//                         <div className="sub-list">
//                           {cat.subcategories.map((sub) => (
//                             <div className="sub-item" key={sub._id}>
//                               <div className="sub-left">
//                                 {sub.image ? (
//                                   <img
//                                     src={sub.image}
//                                     className="sub-thumb"
//                                     alt=""
//                                   />
//                                 ) : (
//                                   <div className="sub-thumb no-img">No</div>
//                                 )}

//                                 <div className="sub-name">{sub.name}</div>
//                               </div>

//                               <div className="dots-wrap">
//                                 <button
//                                   className="dots-btn small-dots"
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     setOpenMenuId(
//                                       openMenuId === sub._id
//                                         ? null
//                                         : sub._id
//                                     );
//                                   }}
//                                 >
//                                   ⋯
//                                 </button>

//                                 {openMenuId === sub._id && (
//                                   <div className="dots-menu">
//                                     <button
//                                       className="menu-item"
//                                       onClick={() => {
//                                         openSubModal(cat, sub);
//                                         setOpenMenuId(null);
//                                       }}
//                                     >
//                                       Edit
//                                     </button>

//                                     <button
//                                       className="menu-item"
//                                       onClick={() => {
//                                         deleteSub(cat._id, sub._id);
//                                         setOpenMenuId(null);
//                                       }}
//                                     >
//                                       Delete
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           ))}
//                         </div>

//                         {/* SUB FORM */}
//                         <form
//                           className="sub-form"
//                           onSubmit={(e) => submitSub(e, cat._id)}
//                         >
//                           <input
//                             name="name"
//                             type="text"
//                             placeholder="Subcategory name"
//                             value={subForm.name}
//                             onChange={onSubInputChange}
//                           />

//                           <input
//                             name="image"
//                             type="file"
//                             accept="image/*"
//                             onChange={onSubInputChange}
//                           />

//                           <button type="submit">
//                             {editSubInfo.subId ? "Update Sub" : "Add Sub"}
//                           </button>
//                         </form>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* PAGINATION */}
//       <div className="pagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Prev
//         </button>

//         {Array.from({ length: totalPages }).map((_, i) => (
//           <button
//             key={i}
//             className={currentPage === i + 1 ? "active-page" : ""}
//             onClick={() => setCurrentPage(i + 1)}
//           >
//             {i + 1}
//           </button>
//         ))}

//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>

//       {/* EDIT POPUP */}
//       {isModalOpen && (
//         <div className="cm-modal-overlay" onMouseDown={closeModal}>
//           <div className="cm-modal" onMouseDown={(e) => e.stopPropagation()}>
//             <h3>
//               {modalMode === "category"
//                 ? "Edit Category"
//                 : "Edit Subcategory"}
//             </h3>

//             <form onSubmit={saveModal} className="cm-modal-form">
//               {modalMode === "category" ? (
//                 <>
//                   <label className="modal-label">Name</label>
//                   <input
//                     name="name"
//                     value={catForm.name}
//                     onChange={(e) =>
//                       setCatForm((p) => ({ ...p, name: e.target.value }))
//                     }
//                   />

//                   <label className="modal-label">Image</label>
//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/*"
//                     onChange={handleModalImageChange}
//                   />

//                   {modalPreview && (
//                     <div className="modal-preview">
//                       <img src={modalPreview} alt="preview" />
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <>
//                   <label className="modal-label">Subcategory Name</label>
//                   <input
//                     name="name"
//                     value={subForm.name}
//                     onChange={(e) =>
//                       setSubForm((p) => ({ ...p, name: e.target.value }))
//                     }
//                   />

//                   <label className="modal-label">Image</label>
//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/*"
//                     onChange={handleModalImageChange}
//                   />

//                   {modalPreview && (
//                     <div className="modal-preview">
//                       <img src={modalPreview} alt="preview" />
//                     </div>
//                   )}
//                 </>
//               )}

//               <div className="modal-actions">
//                 <button type="submit" className="btn-primary">
//                   Update
//                 </button>

//                 <button type="button" className="btn-cancel" onClick={closeModal}>
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CategoryManager;












import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Search,
  Plus,
  X,
  Edit,
  Trash2,
  ChevronDown,
  ChevronUp,
  Image as ImageIcon,
  ChevronLeft,
  ChevronRight,
  AlertCircle,
  LayoutGrid,
  Folder,
  Check
} from "lucide-react";

const API_BASE = "https://grocerrybackend.vercel.app/api/categories";

const emptyCategoryForm = { name: "", image: null };
const emptySubForm = { name: "", image: null };

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [catForm, setCatForm] = useState(emptyCategoryForm);
  const [editCatId, setEditCatId] = useState(null);
  const [showCatForm, setShowCatForm] = useState(false);

  const [expandedCat, setExpandedCat] = useState(null);

  const [subForm, setSubForm] = useState(emptySubForm);
  const [editSubInfo, setEditSubInfo] = useState({ catId: null, subId: null });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const [searchText, setSearchText] = useState("");

  // Modal Edit Popup
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("category");
  const [modalTarget, setModalTarget] = useState({ catId: null, subId: null });
  const [modalPreview, setModalPreview] = useState(null);
  const fileInputRef = useRef(null);

  /* ------------------- Fetch Categories -------------------- */
  const fetchCategories = async () => {
    try {
      const res = await axios.get(API_BASE);
      const cats = res.data.categories || res.data.data || [];

      setCategories(
        cats.map((c) => ({
          ...c,
          subcategories: Array.isArray(c.subcategories)
            ? c.subcategories
            : [],
        }))
      );
    } catch (err) {
      toast.error("Failed to load categories");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  /* ------------------- SEARCH FILTER -------------------- */
  const filterCategories = (cats, q) => {
    if (!q || !q.trim()) return cats;

    const t = q.toLowerCase();

    return cats
      .map((c) => {
        const matchedSubs = c.subcategories.filter((s) =>
          s.name.toLowerCase().includes(t)
        );

        const categoryMatches = c.name.toLowerCase().includes(t);

        if (categoryMatches) return c;

        if (matchedSubs.length) {
          return { ...c, subcategories: matchedSubs };
        }

        return null;
      })
      .filter(Boolean);
  };

  /* ------------------- CATEGORY INPUT -------------------- */
  const onCatInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) setCatForm((p) => ({ ...p, image: files[0] }));
    else setCatForm((p) => ({ ...p, [name]: value }));
  };

  /* ------------------- SUB INPUT -------------------- */
  const onSubInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) setSubForm((p) => ({ ...p, image: files[0] }));
    else setSubForm((p) => ({ ...p, [name]: value }));
  };

  /* ------------------- SAVE CATEGORY -------------------- */
  const submitCategory = async (e) => {
    e.preventDefault();

    if (!catForm.name.trim()) return toast.warn("Enter category name");

    const fd = new FormData();
    fd.append("name", catForm.name);
    if (catForm.image) fd.append("image", catForm.image);

    try {
      if (editCatId) {
        await axios.put(`${API_BASE}/${editCatId}`, fd);
        toast.success("Category updated");
      } else {
        await axios.post(API_BASE, fd);
        toast.success("Category added");
      }

      setCatForm(emptyCategoryForm);
      setEditCatId(null);
      setShowCatForm(false);
      fetchCategories();
    } catch (err) {
      toast.error("Failed to save category");
    }
  };

  /* ------------------- DELETE CATEGORY -------------------- */
  const deleteCategory = async (id) => {
    if (!window.confirm("Delete this category and all its subcategories?")) return;

    try {
      await axios.delete(`${API_BASE}/${id}`);
      toast.success("Category deleted");
      fetchCategories();
    } catch {
      toast.error("Failed to delete category");
    }
  };

  /* ------------------- SAVE SUBCATEGORY -------------------- */
  const submitSub = async (e, catId) => {
    e.preventDefault();
    if (!subForm.name.trim()) return toast.warn("Enter subcategory name");

    const fd = new FormData();
    fd.append("name", subForm.name);
    if (subForm.image) fd.append("image", subForm.image);

    try {
      if (editSubInfo.subId) {
        await axios.put(
          `${API_BASE}/${editSubInfo.catId}/sub/${editSubInfo.subId}`,
          fd
        );
        toast.success("Subcategory updated");
      } else {
        await axios.post(`${API_BASE}/${catId}/sub`, fd);
        toast.success("Subcategory added");
      }

      setSubForm(emptySubForm);
      setEditSubInfo({ catId: null, subId: null });
      fetchCategories();
    } catch {
      toast.error("Failed to save subcategory");
    }
  };

  /* ------------------- DELETE SUBCATEGORY -------------------- */
  const deleteSub = async (catId, subId) => {
    if (!window.confirm("Delete this subcategory?")) return;

    try {
      await axios.delete(`${API_BASE}/${catId}/sub/${subId}`);
      toast.success("Subcategory deleted");
      fetchCategories();
    } catch {
      toast.error("Failed to delete subcategory");
    }
  };

  /* ------------------- MODAL HANDLERS -------------------- */
  const openCategoryModal = (cat) => {
    setModalMode("category");
    setModalTarget({ catId: cat._id, subId: null });
    setModalPreview(cat.image);
    setCatForm({ name: cat.name, image: null });
    setIsModalOpen(true);
  };

  const openSubModal = (cat, sub) => {
    setModalMode("subcategory");
    setModalTarget({ catId: cat._id, subId: sub._id });
    setModalPreview(sub.image);
    setSubForm({ name: sub.name, image: null });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalPreview(null);
    setModalTarget({ catId: null, subId: null });
    setCatForm(emptyCategoryForm);
    setSubForm(emptySubForm);
  };

  const handleModalImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setModalPreview(URL.createObjectURL(file));
      if (modalMode === "category")
        setCatForm((p) => ({ ...p, image: file }));
      else setSubForm((p) => ({ ...p, image: file }));
    }
  };

  const saveModal = async (e) => {
    e.preventDefault();

    try {
      const fd = new FormData();

      if (modalMode === "category") {
        fd.append("name", catForm.name);
        if (catForm.image) fd.append("image", catForm.image);

        await axios.put(`${API_BASE}/${modalTarget.catId}`, fd);
        toast.success("Category updated");
      } else {
        fd.append("name", subForm.name);
        if (subForm.image) fd.append("image", subForm.image);

        await axios.put(
          `${API_BASE}/${modalTarget.catId}/sub/${modalTarget.subId}`,
          fd
        );
        toast.success("Subcategory updated");
      }

      closeModal();
      fetchCategories();
    } catch {
      toast.error("Update failed");
    }
  };

  /* ------------------- PAGINATION -------------------- */
  const filtered = filterCategories(categories, searchText);
  const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [filtered.length, totalPages]);

  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentCats = filtered.slice(firstIndex, lastIndex);

  /* ------------------- UI -------------------- */
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* HEADER SECTION */}
      <>
        {/* <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4 mb-3 md:mb-4"> */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4 mb-3 md:mb-4">
            <h1 className="text-lg md:text-2xl font-bold text-gray-900">Category Manager</h1>
            <p className="text-xs md:text-sm text-gray-600 mt-0.5">Manage categories & subcategories</p>
          
          
          <div className="flex gap-2 md:gap-3">
            <div className="bg-white p-2 md:p-3 rounded-lg border border-gray-200 text-center min-w-[70px] md:min-w-[90px]">
              <div className="text-sm md:text-lg font-bold text-blue-600">{categories.length}</div>
              <div className="text-xs text-gray-500">Categories</div>
            </div>
            <div className="bg-white p-2 md:p-3 rounded-lg border border-gray-200 text-center min-w-[70px] md:min-w-[90px]">
              <div className="text-sm md:text-lg font-bold text-emerald-600">
                {categories.reduce((acc, cat) => acc + cat.subcategories.length, 0)}
              </div>
              <div className="text-xs text-gray-500">Subcategories</div>
            </div>
          </div>
          </div>
        {/* </div> */}

        {/* SEARCH AND ACTIONS BAR */}
        <div className="flex flex-col sm:flex-row gap-2 mb-4">
          <div className="relative flex-1">
            <Search className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-gray-400 h-3.5 w-3.5 md:h-4 md:w-4" />
            <input
              type="text"
              className="w-full pl-8 pr-7 md:pl-9 md:pr-8 py-2 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              placeholder="Search categories..."
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
            />
            {searchText && (
              <button 
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                onClick={() => setSearchText("")}
              >
                <X className="h-3.5 w-3.5 md:h-4 md:w-4" />
              </button>
            )}
          </div>

          <button
            className={`flex items-center justify-center gap-1 px-3 py-2 text-xs md:text-sm rounded-lg font-medium transition-all ${
              showCatForm 
                ? "bg-gray-100 text-gray-700 hover:bg-gray-200" 
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
            onClick={() => setShowCatForm(!showCatForm)}
          >
            {showCatForm ? (
              <>
                <X className="h-3.5 w-3.5" />
                <span>Cancel</span>
              </>
            ) : (
              <>
                <Plus className="h-3.5 w-3.5" />
                <span>Add Category</span>
              </>
            )}
          </button>
        </div>
      </>

      {/* CATEGORY FORM */}
      {showCatForm && (
        <div className="bg-white rounded-lg border border-gray-200 p-3 md:p-4 mb-4 animate-fadeIn">
          <div className="flex items-center gap-2 mb-3">
            <LayoutGrid className="h-4 w-4 text-blue-600" />
            <h3 className="text-sm font-semibold text-gray-900">
              {editCatId ? "Edit Category" : "Create New Category"}
            </h3>
          </div>
          
          <form onSubmit={submitCategory}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Category Name <span className="text-red-500">*</span>
                </label>
                <input
                  name="name"
                  type="text"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="Enter category name"
                  value={catForm.name}
                  onChange={onCatInputChange}
                  required
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Category Image
                </label>
                <label className="flex items-center gap-2 px-3 py-2 text-sm border border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all group">
                  <ImageIcon className="h-3.5 w-3.5 text-gray-400 group-hover:text-blue-500" />
                  <span className="text-gray-600 truncate">
                    {catForm.image ? catForm.image.name : "Choose image"}
                  </span>
                  <input
                    name="image"
                    type="file"
                    accept="image/*"
                    onChange={onCatInputChange}
                    className="hidden"
                  />
                </label>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 pt-3 border-t border-gray-200">
              <button
                type="submit"
                className="flex items-center justify-center gap-1 px-3 py-2 text-sm bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-all flex-1"
              >
                <Check className="h-3.5 w-3.5" />
                {editCatId ? "Update" : "Create"}
              </button>
              <button
                type="button"
                className="flex items-center justify-center gap-1 px-3 py-2 text-sm bg-white text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-all flex-1"
                onClick={() => {
                  setCatForm(emptyCategoryForm);
                  setEditCatId(null);
                  setShowCatForm(false);
                }}
              >
                <X className="h-3.5 w-3.5" />
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* MOBILE VIEW - SIMPLE CARDS (EQUAL SIZE) */}
      <div className="md:hidden">
        {currentCats.length === 0 ? (
          <div className="bg-white rounded-lg border border-gray-200 p-6 text-center">
            <AlertCircle className="h-8 w-8 text-gray-400 mx-auto mb-2" />
            <p className="text-sm font-medium text-gray-600 mb-1">No categories found</p>
            <p className="text-xs text-gray-500">
              {searchText ? "Try a different search term" : "Add your first category"}
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {currentCats.map((cat) => (
              <div key={cat._id} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                {/* Category Card */}
                <div className="p-3 border-b border-gray-100">
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                      <div className="w-10 h-10 rounded-lg overflow-hidden bg-gray-100 border border-gray-200 flex-shrink-0">
                        {cat.image ? (
                          <img 
                            src={cat.image} 
                            alt={cat.name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center">
                            <ImageIcon className="h-5 w-5 text-gray-400" />
                          </div>
                        )}
                      </div>
                      <div className="min-w-0 flex-1">
                        <h3 className="font-medium text-sm text-gray-900 truncate">{cat.name}</h3>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100">
                            {cat.subcategories.length} subs
                          </span>
                          <button
                            onClick={() => setExpandedCat(expandedCat === cat._id ? null : cat._id)}
                            className="flex items-center gap-0.5 text-xs text-blue-600 hover:text-blue-800"
                          >
                            {expandedCat === cat._id ? "Hide" : "Show"}
                            {expandedCat === cat._id ? (
                              <ChevronUp className="h-3 w-3" />
                            ) : (
                              <ChevronDown className="h-3 w-3" />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-1 ml-2 flex-shrink-0">
                      <button
                        onClick={() => openCategoryModal(cat)}
                        className="p-1.5 text-emerald-600 hover:bg-emerald-50 rounded"
                      >
                        <Edit className="h-3.5 w-3.5" />
                      </button>
                      <button
                        onClick={() => deleteCategory(cat._id)}
                        className="p-1.5 text-red-600 hover:bg-red-50 rounded"
                      >
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Expanded Subcategories - Separate Section */}
                {expandedCat === cat._id && (
                  <div className="border-t border-gray-100 bg-gray-50">
                    <div className="p-3">
                      <div className="flex items-center gap-2 mb-3">
                        <Folder className="h-4 w-4 text-blue-600" />
                        <h4 className="text-sm font-medium text-gray-900">
                          Subcategories ({cat.subcategories.length})
                        </h4>
                      </div>
                      
                      {/* Subcategories List */}
                      {cat.subcategories.length === 0 ? (
                        <div className="bg-white rounded border border-gray-200 p-3 text-center">
                          <p className="text-xs text-gray-500">No subcategories yet</p>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          {cat.subcategories.map((sub) => (
                            <div key={sub._id} className="bg-white rounded border border-gray-200 p-2">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                  <div className="w-8 h-8 rounded overflow-hidden bg-gray-100">
                                    {sub.image ? (
                                      <img 
                                        src={sub.image} 
                                        alt={sub.name}
                                        className="w-full h-full object-cover"
                                      />
                                    ) : (
                                      <div className="w-full h-full flex items-center justify-center">
                                        <ImageIcon className="h-3 w-3 text-gray-400" />
                                      </div>
                                    )}
                                  </div>
                                  <span className="text-sm text-gray-900">{sub.name}</span>
                                </div>
                                <div className="flex gap-1">
                                  <button
                                    onClick={() => openSubModal(cat, sub)}
                                    className="p-1 text-emerald-600 hover:bg-emerald-50 rounded"
                                  >
                                    <Edit className="h-3 w-3" />
                                  </button>
                                  <button
                                    onClick={() => deleteSub(cat._id, sub._id)}
                                    className="p-1 text-red-600 hover:bg-red-50 rounded"
                                  >
                                    <Trash2 className="h-3 w-3" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Add Subcategory Form */}
                      <div className="mt-4 bg-white rounded border border-gray-200 p-3">
                        <h5 className="text-xs font-medium text-gray-900 mb-2">
                          {editSubInfo.subId ? "Edit Subcategory" : "Add Subcategory"}
                        </h5>
                        <form onSubmit={(e) => submitSub(e, cat._id)}>
                          <div className="space-y-2">
                            <input
                              name="name"
                              type="text"
                              className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                              placeholder="Subcategory name"
                              value={subForm.name}
                              onChange={onSubInputChange}
                            />
                            <div className="flex items-center gap-2">
                              <label className="flex items-center gap-1.5 flex-1 px-2 py-1.5 text-sm border border-dashed border-gray-300 rounded cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all">
                                <ImageIcon className="h-3 w-3 text-gray-400" />
                                <span className="text-gray-600 truncate">
                                  {subForm.image ? subForm.image.name : "Image"}
                                </span>
                                <input
                                  name="image"
                                  type="file"
                                  accept="image/*"
                                  onChange={onSubInputChange}
                                  className="hidden"
                                />
                              </label>
                              <button
                                type="submit"
                                className="px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 transition-colors"
                              >
                                {editSubInfo.subId ? "Update" : "Add"}
                              </button>
                            </div>
                            {editSubInfo.subId && (
                              <button
                                type="button"
                                className="w-full px-3 py-1.5 bg-gray-100 text-gray-700 text-xs font-medium rounded hover:bg-gray-200 transition-colors"
                                onClick={() => setEditSubInfo({ catId: null, subId: null })}
                              >
                                Cancel Edit
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* DESKTOP VIEW - TABLE */}
      <div className="hidden md:block bg-white rounded-lg border border-gray-200 overflow-hidden">
        {/* Table Header */}
        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">
            Categories ({filtered.length})
          </h3>
          <div className="text-xs text-gray-600">
            Showing {Math.min(lastIndex, filtered.length)} of {filtered.length}
          </div>
        </div>

        {/* Table Container */}
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
                <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase">Image</th>
                <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase">Subcategories</th>
                <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentCats.length === 0 ? (
                <tr>
                  <td colSpan="5" className="py-8 px-6 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <AlertCircle className="h-8 w-8 text-gray-400 mb-2" />
                      <p className="text-sm font-medium text-gray-600 mb-1">No categories found</p>
                      <p className="text-xs text-gray-500">
                        {searchText ? "Try a different search term" : "Add your first category"}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                currentCats.map((cat, i) => (
                  <React.Fragment key={cat._id}>
                    {/* Main Category Row */}
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="py-2 px-3">
                        <span className="text-xs font-medium text-gray-900">{firstIndex + i + 1}</span>
                      </td>
                      
                      <td className="py-2 px-3">
                        <div className="w-10 h-10 rounded overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center">
                          {cat.image ? (
                            <img 
                              src={cat.image} 
                              alt={cat.name}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <ImageIcon className="h-4 w-4 text-gray-400" />
                          )}
                        </div>
                      </td>
                      
                      <td className="py-2 px-3">
                        <div>
                          <div className="font-medium text-sm text-gray-900">{cat.name}</div>
                          <div className="text-xs text-gray-500 font-mono mt-0.5">
                            ID: {cat._id?.substring(0, 6)}...
                          </div>
                        </div>
                      </td>
                      
                      <td className="py-2 px-3">
                        <div className="flex items-center gap-2">
                          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
                            {cat.subcategories.length}
                          </span>
                          <button
                            className="flex items-center gap-1 text-xs text-gray-600 hover:text-blue-600 transition-colors"
                            onClick={() => setExpandedCat(expandedCat === cat._id ? null : cat._id)}
                          >
                            {expandedCat === cat._id ? (
                              <>
                                <ChevronUp className="h-3 w-3" />
                                <span>Hide</span>
                              </>
                            ) : (
                              <>
                                <ChevronDown className="h-3 w-3" />
                                <span>Manage</span>
                              </>
                            )}
                          </button>
                        </div>
                      </td>
                      
                      <td className="py-2 px-3">
                        <div className="flex items-center gap-1">
                          <button
                            onClick={() => openCategoryModal(cat)}
                            className="p-1.5 text-emerald-600 hover:bg-emerald-50 rounded"
                            title="Edit category"
                          >
                            <Edit className="h-3.5 w-3.5" />
                          </button>
                          <button
                            onClick={() => deleteCategory(cat._id)}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded"
                            title="Delete category"
                          >
                            <Trash2 className="h-3.5 w-3.5" />
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* Expanded Subcategories Section */}
                    {expandedCat === cat._id && (
                      <tr>
                        <td colSpan="5" className="p-0">
                          <div className="bg-gray-50 border-t border-gray-200 p-4">
                            <div className="flex items-center justify-between gap-4 mb-4">
                              <div className="flex items-center gap-2">
                                <Folder className="h-4 w-4 text-blue-600" />
                                <h4 className="text-sm font-semibold text-gray-900">
                                  Subcategories of {cat.name}
                                </h4>
                              </div>
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                                {cat.subcategories.length} subcategories
                              </span>
                            </div>

                            {/* Subcategories Grid */}
                            {cat.subcategories.length === 0 ? (
                              <div className="text-center py-4 bg-white rounded border border-gray-200 mb-4">
                                <p className="text-xs text-gray-500">No subcategories yet. Add one below.</p>
                              </div>
                            ) : (
                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                                {cat.subcategories.map((sub) => (
                                  <div key={sub._id} className="bg-white rounded border border-gray-200 overflow-hidden hover:shadow-sm transition-shadow">
                                    <div className="h-20 bg-gray-100 overflow-hidden">
                                      {sub.image ? (
                                        <img 
                                          src={sub.image} 
                                          alt={sub.name}
                                          className="w-full h-full object-cover"
                                        />
                                      ) : (
                                        <div className="w-full h-full flex items-center justify-center">
                                          <ImageIcon className="h-5 w-5 text-gray-400" />
                                        </div>
                                      )}
                                    </div>
                                    <div className="p-2">
                                      <h5 className="font-medium text-xs text-gray-900 mb-1 truncate">{sub.name}</h5>
                                      <div className="flex justify-end gap-1">
                                        <button
                                          onClick={() => openSubModal(cat, sub)}
                                          className="p-1 text-emerald-600 hover:bg-emerald-50 rounded"
                                          title="Edit subcategory"
                                        >
                                          <Edit className="h-3 w-3" />
                                        </button>
                                        <button
                                          onClick={() => deleteSub(cat._id, sub._id)}
                                          className="p-1 text-red-600 hover:bg-red-50 rounded"
                                          title="Delete subcategory"
                                        >
                                          <Trash2 className="h-3 w-3" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Add Subcategory Form */}
                            <div className="bg-white rounded border border-gray-200 p-3">
                              <h5 className="text-xs font-semibold text-gray-900 mb-2">
                                {editSubInfo.subId ? "Edit Subcategory" : "Add New Subcategory"}
                              </h5>
                              <form onSubmit={(e) => submitSub(e, cat._id)}>
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                                  <div className="md:col-span-2">
                                    <input
                                      name="name"
                                      type="text"
                                      className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                      placeholder="Subcategory name"
                                      value={subForm.name}
                                      onChange={onSubInputChange}
                                    />
                                  </div>
                                  <div>
                                    <label className="flex items-center gap-1.5 px-2 py-1.5 text-sm border border-dashed border-gray-300 rounded cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all group">
                                      <ImageIcon className="h-3 w-3 text-gray-400 group-hover:text-blue-500" />
                                      <span className="text-xs text-gray-600 truncate">
                                        {subForm.image ? subForm.image.name : "Choose image"}
                                      </span>
                                      <input
                                        name="image"
                                        type="file"
                                        accept="image/*"
                                        onChange={onSubInputChange}
                                        className="hidden"
                                      />
                                    </label>
                                  </div>
                                  <div className="flex gap-1">
                                    <button
                                      type="submit"
                                      className="flex-1 px-2 py-1.5 text-xs bg-blue-600 text-white font-medium rounded hover:bg-blue-700 transition-colors"
                                    >
                                      {editSubInfo.subId ? "Update" : "Add"}
                                    </button>
                                    {editSubInfo.subId && (
                                      <button
                                        type="button"
                                        className="px-2 py-1.5 text-xs bg-gray-100 text-gray-700 font-medium rounded hover:bg-gray-200 transition-colors"
                                        onClick={() => setEditSubInfo({ catId: null, subId: null })}
                                      >
                                        Cancel
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}
      {filtered.length > 0 && (
        <div className="mt-3 md:mt-4 flex flex-col sm:flex-row items-center justify-between gap-2 bg-white rounded-lg border border-gray-200 p-2 md:p-3">
          <div className="text-xs text-gray-600">
            Showing {firstIndex + 1} to {Math.min(lastIndex, filtered.length)} of {filtered.length}
          </div>
          <div className="flex items-center gap-1">
            <button
              className={`flex items-center gap-1 px-2 py-1 text-xs rounded border ${
                currentPage === 1
                  ? "border-gray-200 text-gray-400 cursor-not-allowed"
                  : "border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              <ChevronLeft className="h-3 w-3" />
              <span className="hidden sm:inline">Prev</span>
            </button>
            
            <div className="flex gap-0.5">
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  className={`w-7 h-7 flex items-center justify-center text-xs rounded ${
                    currentPage === i + 1
                      ? "bg-blue-600 text-white"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
            </div>
            
            <button
              className={`flex items-center gap-1 px-2 py-1 text-xs rounded border ${
                currentPage === totalPages
                  ? "border-gray-200 text-gray-400 cursor-not-allowed"
                  : "border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              <span className="hidden sm:inline">Next</span>
              <ChevronRight className="h-3 w-3" />
            </button>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {isModalOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-3 z-50 animate-fadeIn"
          onClick={closeModal}
        >
          <div 
            className="bg-white rounded-lg w-full max-w-sm max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between p-3 border-b border-gray-200">
              <h3 className="text-sm font-semibold text-gray-900">
                {modalMode === "category" ? "Edit Category" : "Edit Subcategory"}
              </h3>
              <button
                onClick={closeModal}
                className="p-1 hover:bg-gray-100 rounded transition-colors"
              >
                <X className="h-4 w-4 text-gray-500" />
              </button>
            </div>

            {/* Modal Form */}
            <form onSubmit={saveModal} className="p-3">
              <div className="space-y-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    {modalMode === "category" ? "Category Name" : "Subcategory Name"}
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    value={modalMode === "category" ? catForm.name : subForm.name}
                    onChange={(e) =>
                      modalMode === "category"
                        ? setCatForm((p) => ({ ...p, name: e.target.value }))
                        : setSubForm((p) => ({ ...p, name: e.target.value }))
                    }
                    required
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Image
                  </label>
                  <div 
                    className="border border-dashed border-gray-300 rounded p-4 text-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all group"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {modalPreview ? (
                      <div className="max-h-32 overflow-hidden rounded">
                        <img 
                          src={modalPreview} 
                          alt="Preview" 
                          className="w-full h-auto max-h-28 object-contain"
                        />
                      </div>
                    ) : (
                      <>
                        <ImageIcon className="h-6 w-6 text-gray-400 mx-auto mb-1.5 group-hover:text-blue-500" />
                        <p className="text-xs text-gray-600 font-medium">Click to upload image</p>
                        <p className="text-xs text-gray-500 mt-0.5">PNG, JPG, WEBP up to 5MB</p>
                      </>
                    )}
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleModalImageChange}
                      className="hidden"
                    />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-2 pt-3 border-t border-gray-200">
                  <button
                    type="submit"
                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-sm bg-blue-600 text-white font-medium rounded hover:bg-blue-700 transition-colors"
                  >
                    <Check className="h-3.5 w-3.5" />
                    Update Changes
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="flex-1 px-3 py-2 text-sm bg-gray-100 text-gray-700 font-medium rounded hover:bg-gray-200 transition-colors"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add custom animation styles */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default CategoryManager;